export const TABLE_TYPES = {
    oil: 'oil',
    gas: 'gas',
    water: 'water',
    inject: 'inject',
}
